import React, { useEffect, useState } from "react";
import { Gauge } from "lucide-react";
import { videoIntelMeter } from "../lib/api";

const tone = (s) => (s > 60 ? "#10B981" : s >= 40 ? "#F59E0B" : "#EF4444");
const ARC = Math.PI * 50;

const Semi = ({ name, m, testid }) => {
  const s = m?.score;
  const c = s == null ? "#475569" : tone(s);
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <svg viewBox="0 0 120 70" className="w-full max-w-[170px]">
        <path d="M10 62 A50 50 0 0 1 110 62" fill="none" stroke="#ffffff14" strokeWidth="10" strokeLinecap="round" />
        {s != null && <path d="M10 62 A50 50 0 0 1 110 62" fill="none" stroke={c} strokeWidth="10" strokeLinecap="round"
          strokeDasharray={`${(ARC * s) / 100} ${ARC}`} style={{ filter: `drop-shadow(0 0 6px ${c}88)`, transition: "stroke-dasharray 700ms" }} />}
        <text x="60" y="58" textAnchor="middle" className="nx-orbitron" fontSize={s == null ? 7 : 20} fontWeight="900" fill={c}>
          {s == null ? "NOT ENOUGH DATA" : s}
        </text>
      </svg>
      <p className="nx-orbitron text-[11px] tracking-[0.25em] font-bold text-cyan-100 mt-1">{name}</p>
      <p className="nx-mono text-[10px] text-cyan-100/50" data-testid={`${testid}-samples`}>
        {m?.pick_samples ?? 0} picks · {m?.trade_samples ?? 0} tagged trades
      </p>
    </div>
  );
};

export const VideoIntelMeter = () => {
  const [m, setM] = useState(null);
  useEffect(() => { videoIntelMeter().then(setM).catch(() => setM({})); }, []);
  return (
    <div className="nx-glass rounded-2xl p-4 flex flex-col" data-testid="intel-video-meter">
      <div className="flex items-center gap-2 mb-3">
        <Gauge className="w-4 h-4 text-[#A78BFA]" />
        <span className="nx-orbitron text-xs tracking-[0.25em] font-bold text-[#A78BFA]">VIDEO INTEL USEFULNESS</span>
        <span className="ml-auto nx-mono text-[9px] text-cyan-100/40">60% PICK HIT · 40% TAGGED WINS</span>
      </div>
      <div className="grid grid-cols-2 gap-3 flex-1 items-center">
        <Semi name="NEXUS" m={m?.nexus} testid="video-meter-nexus" />
        <Semi name="HERCULES" m={m?.hercules} testid="video-meter-hercules" />
      </div>
    </div>
  );
};
